import type { AltType, LoginStrategy } from '@/utils/const'

import { requests } from '.'
interface BaseParams {
  altId: string
  altType: AltType
}
interface GenerateOTPParams extends BaseParams {
  email: string
  storeId: string
  turnstileToken?: string
  turnstileType?: 'invisible' | 'normal'
}
interface LoginWithOTPParams extends BaseParams {
  otp: string
  storeId: string
  contactId: string
  email: string
  strategy: LoginStrategy
}
export const AuthService = {
  generateOtp: (params: GenerateOTPParams) => requests().post('/generate-otp', params),
  loginWithOtp: (params: LoginWithOTPParams) => requests().post('/login', params),
}
